import type { AxiosResponse } from 'axios';

import fromImgToUrl from '@/utils/fromImgToUrl';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type {
  IUser, PermissionsRequestBody, PermissionsResponse, UserCreateBody, UserUpdateBody,
} from './types';

export const getAll = (): Promise<void | AxiosResponse<IUser []>> => axiosInstance({
  url: ROUTES.USERS,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getById = (id: string): Promise<void | AxiosResponse<IUser>> => axiosInstance({
  url: `${ROUTES.USERS}/${id}`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getLogoByUserId = (id: string): Promise<void | AxiosResponse<string>> => axiosInstance({
  url: `${ROUTES.USERS}/${id}/logo`,
  responseType: 'arraybuffer',
  transformResponse: (res) => fromImgToUrl(res),
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getCurrent = (): Promise<void | AxiosResponse<IUser>> => axiosInstance({
  url: `${ROUTES.USERS}/current`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getCurrentLogo = (): Promise<void | AxiosResponse<string>> => axiosInstance({
  url: `${ROUTES.USERS}/current/logo`,
  responseType: 'arraybuffer',
  transformResponse: (res) => fromImgToUrl(res),
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const create = (data: UserCreateBody): Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.USERS}/${data.id}`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const createLogo = (id: string, data: File): Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.USERS}/${id}/logo`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const update = (data: UserUpdateBody): Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.USERS}/${data.id}`,
  method: 'PATCH',
  headers: {
    authorization: true,
  },
  data,
});

export const remove = (id: string): Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.USERS}/${id}`,
  method: 'DELETE',
  headers: {
    authorization: true,
  },
});

export const removeLogo = (id: string): Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.USERS}/${id}/logo`,
  method: 'DELETE',
  headers: {
    authorization: true,
  },
});

export const getCurrentPermissions = <T = PermissionsResponse>(data: PermissionsRequestBody[])
: Promise<AxiosResponse<T>> => axiosInstance(
    {
      url: `${ROUTES.USERS}/current/perm`,
      method: 'POST',
      headers: {
        authorization: true,
      },
      data,
    },
  );

export const generateTgLink = (id: string): Promise<void | AxiosResponse<
  { tg_link: string, tg_link_exp: number }>
  > => axiosInstance({
  url: `${ROUTES.USERS}/${id}/tg-link`,
  method: 'POST',
  headers: {
    authorization: true,
  },
});

export const deleteTgLink = (id: string): Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.USERS}/${id}/tg-link`,
  method: 'DELETE',
  headers: {
    authorization: true,
  },
});
